import { Component, signal } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { LocationTheftReport } from '../../../../types';
import { AccessLogDialogComponent } from '../../../tabs/report-portal/access-log-dialog';

type CellParams = ICellRendererParams<LocationTheftReport>;

@Component({
  selector: 'app-pan-cell-report-portal-actions',
  imports: [UiModule, MatTooltipModule, RouterModule, AccessLogDialogComponent],
  templateUrl: './cell-report-portal-actions.component.html',
  styleUrl: './cell-report-portal-actions.component.scss',
})
export class CellReportPortalActionsComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  public showAccessLog = signal<boolean>(false);

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
